const formFieldsOutbound = [
  {
    key: 'materialTypeName',
    label: 'Product / Material',
    type: 'text',
    isRequired: true,
  },
  // {
  //   key: 'specialConsideration',
  //   label: 'Special Consideration',
  //   type: 'select',
  //   options: [
  //     { label: 'Yes', value: true },
  //     { label: 'No', value: false },
  //   ],
  // },
  {
    key: 'commentary',
    label: 'Commentary',
    type: 'textArea',
    dependency: 'specialConsideration',
  },
  { type: 'autocomplete' },
];

export { formFieldsOutbound };
